import { baseApi } from "./baseApi";

/**
 * Access-aware community-listing slice for the dashboard Overview community
 * selector (SW-DASH-1 B1).
 *
 * Distinct from skycrmCommunitiesApi, which hits the admin-only, unscoped
 * /skycrm/communities. This slice hits /crm/communities/accessible — usable
 * by any CRM-authenticated user and filtered through the per-user
 * community-access ceiling. `allAccess` tells the frontend the ceiling shape
 * (true = all_communities / instance-wide).
 */

export interface AccessibleCommunity {
  id: string;
  name: string;
  /**
   * Community IANA timezone (skycrm_organizations.timezone, V069). null when the community has no
   * tz set -> the community-zone display floors to personal. Added for the global community filter.
   */
  timezone: string | null;
}

export const crmCommunitiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccessibleCommunities: builder.query<
      { communities: AccessibleCommunity[]; allAccess: boolean },
      { instanceId: string }
    >({
      query: ({ instanceId }) => ({
        url: "/crm/communities/accessible",
        params: { instanceId },
      }),
      providesTags: [{ type: "CrmCommunities" as const, id: "LIST" }],
    }),
  }),
});

export const { useGetAccessibleCommunitiesQuery } = crmCommunitiesApi;
